import { Option, OptionValue } from 'components/TreeSelect';
import { AuthUser, HierarchyType } from 'services/resources';

// eslint-disable-next-line import/prefer-default-export
export const mapDealershipHierarchyForDropdowns = (hierarchy: Option<OptionValue>[], user: AuthUser) => {
  const mappedHierarchy = hierarchy.map((dealership) => {
    if (dealership.value === HierarchyType.SELF) {
      return { value: user.profile.dealership.id, label: user.profile.dealership.name };
    }
    return dealership;
  });

  return mappedHierarchy;
};
